import { QUESTION_BLANK } from "../constants";
import KeyboardHint from "./KeyboardHint";

const QuestionWithBlanks = ({ title, hints, answer }) => {
  const blankIndex = title.indexOf(QUESTION_BLANK);
  const firstBlankHint = hints?.filter((hint) => hint.blanks)?.[0];
  const inlineHint = firstBlankHint?.blanks;
  if (blankIndex === -1) {
    return title;
  }
  // Split up the question and splice in the current hint
  title = (
    <>
      {title.substring(0, blankIndex)}
      {answer ? (
        <ins className="font-bold decoration-0">{answer}</ins>
      ) : (
        <KeyboardHint empty={!inlineHint}>{inlineHint || "\xa0"}</KeyboardHint>
      )}
      {title.substring(blankIndex + QUESTION_BLANK.length)}
    </>
  );
  return title;
};

export default QuestionWithBlanks;
